export const companyTel = `8322243440`;
export const telFormatter = (telString: string): string => `(${telString.slice(0, 3)}) ${telString.slice(3, 6)} ${telString.slice(6)}`;
